import {$host} from "./index";

export const fetchStudentCourses = (userId) => $host.get(`/api/students/courses/${userId}`).then(res => res.data);

export const createChat = (courseId) => $host.post('/api/students/chat/create', {course_id: courseId}).then(res => res.data);

export const createAiChat = (courseId) => $host.post('/api/chat/students/ai-chat/create', {course_id: courseId}).then(res => res.data);

export const curatorsChat = async () => {
    const {data} = await $host.get("/api/curators/chats");
    console.log(data);
    return data;
}
